
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const fetchVisitorCounts = async () => {
      try {
        await axiosInstance.get("/api/daily-visitor");
        await axiosInstance.get("/api/total-visitor");
        console.log("Visitor count updated for:", location.pathname);
      } catch (err) {
        console.error("Error updating visitor count:", err);
      }
    };

    fetchVisitorCounts();
  }, [location.pathname]); // runs every time route changes

  return null; // no UI
};

export default VisitorTracker;
